import { ICalendarEntry } from "@/customTypings/calendar/CalendarEntry";
import { IEvent } from "../../components/features/calendar/EventCalendar";
import { foreColorForBack } from "../formatting/formatting";
import dayjs from "dayjs";

export const transformCalendarEntriesToEvents = (
  events: ICalendarEntry[],
  updateEventAllowed: boolean,
  setColors?: (event: ICalendarEntry) => void
): IEvent[] => {
  return events.map((event) => {
    if (setColors) setColors(event);
    
    return {
      id: (event.id ?? "") + (event.identityId ?? ""),
      groupId: event.id ?? "",
      title: event.title ?? "",
      start: event.startDate ?? new Date(),
      end: event.endDate ?? new Date(),
      allDay: event.isAllDay ?? false,
      color: event.color,
      textColor: foreColorForBack(event.color ?? ""),
      editable: updateEventAllowed,
      taskId: event.taskId,
      description: event.description,
      appointmentTypeId: event.appointmentTypeId,
      identityId: event.identityId,
      identityName: event.identityName,
    };
  });
};

export const createEventFromClickInfo = (info: any, calendarRef: any): IEvent => {
  const relatedEvents =
    calendarRef.current
      ?.getApi()
      ?.getEvents()
      ?.filter((event: any) => event.groupId === info.event.groupId) ?? [];

  return {
    id: info.event.id,
    groupId: info.event.groupId,
    title: info.event.title,
    start: info.event.start,
    end: info.event.end,
    allDay: info.event.allDay,
    color: info.event.backgroundColor,
    textColor: info.event.textColor,
    editable: info.el.isContentEditable,
    taskId: info.event.extendedProps.taskId,
    description: info.event.extendedProps.description,
    appointmentTypeId: info.event.extendedProps.appointmentTypeId,
    identityId: info.event.extendedProps.identityId,
    identityName: info.event.extendedProps.identityName,
    associatedIds: relatedEvents.map((e: any) => e.extendedProps.identityId),
  };
};

export const extractIdentityIdsForUpdate = (info: any): string[] => {
  const ids = [info.event.extendedProps.identityId] as string[];
  const related = info.relatedEvents ?? [];
  for (let i = 0; i < related.length; i++) {
    ids.push(related[i].extendedProps.identityId);
  }
  return [...new Set(ids.filter(Boolean))];
};

/**
 * Gets the end date for a calendar event
 * If no end date is provided, calculates one based on all-day status
 */
export const getEventEndDate = (start: Date, end: Date | null, allDay: boolean) => {
  if (end) return dayjs(end);
  
  if (allDay) {
    return dayjs(start).add(1, "day");
  } else {
    return dayjs(start).add(1, "hour");
  }
};
